import React from 'react';
import { Input, Select, Button } from 'semantic-ui-react';
import { formInput, formSelectService } from '../helpers';
import { SingleDatePicker } from 'react-dates';
import moment from '../../services/moment_instance';
import UploadProfilePhoto from '../helpers/guests/upload_photo';
import GuestPlainData from '../helpers/guests/GuestPlainData';
import {
  clearGuestFieldErrors,
  lockedGuestMissingDataMessage,
  shouldLockGuestIdentity,
} from '../helpers/guests/guestIdentity';
import { sanitizeGuestField } from '../helpers/guests/guestFieldValidation';
import { GENDER_OPTIONS } from '../helpers/guests/genderOptions';
import { CIVIL_STATUS_OPTIONS } from '../helpers/guests/civilOptions';
import { CcfFormLayout } from '../../assets/styles/components/CcfForm';

export const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
  let i;
  let years = [];
  for (i = moment().year() + 5; i >= moment().year() - 100; i--) {
    years.push(
      <option value={i} key={`year-${i}`}>
        {i}
      </option>
    );
  }
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div>
        <select value={month.month()} onChange={(e) => onMonthSelect(month, e.target.value)}>
          {moment.months().map((label, value) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
          {years}
        </select>
      </div>
    </div>
  );
};

const Form = (props) => {
  const {
    sendInForm,
    handleInputs,
    submit,
    loadedData,
    Attendant,
    errorInputs,
    showGender,
    showCivil,
    showDate,
    showBirthdate,
    moreInfo,
    showIdentification,
    showPhone,
    showEmail,
    showAge,
    showOcupation,
    showEmergencyContact,
    image,
    set_image,
    allowInlineGuestEdit,
    setErrorInputs,
    onGuestUpdated,
  } = props;
  const {
    lastName,
    name,
    phone,
    identification,
    createdAt,
    email,
    gender,
    civil,
    birthdate,
    ocupation,
    emergencyContactName,
    emergencyContactPhone,
    emergencyContactRelation,
  } = Attendant || {};
  const [focused, set_focused] = React.useState(false);
  const lockGuestIdentity = shouldLockGuestIdentity(Attendant, {
    forceEditable: allowInlineGuestEdit,
  });
  const hasFieldErrors = Object.values(errorInputs || {}).includes(true);

  React.useEffect(() => {
    if (!lockGuestIdentity || typeof setErrorInputs !== 'function') return;
    setErrorInputs((prev) => {
      if (!prev || !Object.values(prev).includes(true)) return prev;
      return clearGuestFieldErrors(prev, Attendant);
    });
  }, [
    lockGuestIdentity,
    Attendant?.name,
    Attendant?.lastName,
    Attendant?.identification,
    Attendant?.phone,
    Attendant?.email,
    Attendant?.gender,
    Attendant?.civil,
    Attendant?.birthdate,
    Attendant?.photo,
  ]);

  const applyHandle = (event) => {
    const { name, value } = event.target;
    handleInputs({
      target: { name, value: sanitizeGuestField(name, value) },
    });
  };

  const selectHandle = (a, { value, name }) => applyHandle({ target: { value, name } });

  return (
    <CcfFormLayout className="ccf-form">
      {lockGuestIdentity && hasFieldErrors && (
        <h4 className="ccf-form__error-heading">{lockedGuestMissingDataMessage}</h4>
      )}
      {lockGuestIdentity && (
        <div className="ccf-form__guest-summary">
          <GuestPlainData
            guest={Attendant}
            onGuestUpdated={onGuestUpdated}
            highlightEdit={hasFieldErrors}
          />
        </div>
      )}
      {!lockGuestIdentity && set_image && (
        <div className="ccf-form__photo">
          <UploadProfilePhoto
            name={'image'}
            labelDescription={'foto'}
            errorInputs={errorInputs}
            imageFile={image}
            filling
            inputs={Attendant}
            set_image={set_image}
          />
        </div>
      )}
      {!lockGuestIdentity && (
        <>
          {formInput({
            Input,
            handler: applyHandle,
            label: 'Nombres',
            name: 'name',
            value: name || '',
            errorInputs,
          })}

          {formInput({
            Input,
            handler: applyHandle,
            label: 'Apellidos',
            name: 'lastName',
            value: lastName || '',
            errorInputs,
          })}

          {showIdentification &&
            formInput({
              Input,
              handler: applyHandle,
              type: 'number',
              label: 'Identificación',
              name: 'identification',
              value: identification || '',
              errorInputs,
            })}

          {showPhone &&
            formInput({
              Input,
              handler: applyHandle,
              label: 'Celular (WhatsApp)',
              name: 'phone',
              value: phone || '',
              errorInputs,
              type: 'number',
            })}

          {showEmail &&
            formInput({
              Input,
              handler: applyHandle,
              label: 'Correo Electrónico',
              name: 'email',
              value: email || '',
              errorInputs,
              type: 'email',
            })}
          {showGender &&
            formSelectService({
              Select,
              handler: selectHandle,
              label: 'Genero',
              name: 'gender',
              value: gender || '',
              errorInputs,
              options: GENDER_OPTIONS,
            })}

          {showCivil &&
            formSelectService({
              Select,
              handler: selectHandle,
              label: 'Estado civil',
              name: 'civil',
              value: civil || '',
              errorInputs,
              options: CIVIL_STATUS_OPTIONS,
            })}

          {showBirthdate && (
            <div
              className={`ccf-form__birthdate birthdate${
                errorInputs?.['birthdate'] ? ' ccf-form__birthdate--error' : ''
              }`}
            >
              <label htmlFor="birthdate">Fecha de nacimiento</label>
              <SingleDatePicker
                date={
                  new Date(birthdate) === 'Invalid Date' || !birthdate ? null : moment(birthdate)
                }
                onDateChange={(newDate) =>
                  applyHandle({
                    target: {
                      value: newDate ? newDate._d : newDate,
                      name: 'birthdate',
                    },
                  })
                }
                focused={focused}
                onFocusChange={({ focused }) => set_focused(focused)}
                placeholder="dd/mm/aaaa"
                showDefaultInputIcon={true}
                block
                noBorder
                numberOfMonths={1}
                displayFormat="DD/MM/YYYY"
                isOutsideRange={() => false}
                id="birthdate"
                renderMonthElement={renderMonthElement}
              />
              {!birthdate && (
                <p className="ccf-form__birthdate-hint">
                  Llena la fecha de nacimiento en números así: dd/mm/aaaa (día/mes/año), ejemplo:
                  31/12/2000
                </p>
              )}
            </div>
          )}
          {showAge && new Date(birthdate) !== 'Invalid Date' && (
            <p className="ccf-form__meta">
              Edad: <strong>{moment().diff(birthdate, 'years')} años</strong>
            </p>
          )}
        </>
      )}
      {showOcupation &&
        formInput({
          Input,
          handler: applyHandle,
          label: 'Profesión',
          name: 'ocupation',
          value: ocupation || '',
          errorInputs,
          type: 'ocupation',
        })}
      {showEmergencyContact && (
        <>
          {formInput({
            Input,
            handler: applyHandle,
            label: 'Nombre de contacto de emergencia',
            name: 'emergencyContactName',
            value: emergencyContactName || '',
            errorInputs,
          })}
          {formInput({
            Input,
            handler: applyHandle,
            label: 'Teléfono de contacto de emergencia',
            name: 'emergencyContactPhone',
            value: emergencyContactPhone || '',
            errorInputs,
            type: 'number',
          })}
          {formInput({
            Input,
            handler: applyHandle,
            label: 'Relación con contacto de emergencia',
            name: 'emergencyContactRelation',
            value: emergencyContactRelation || '',
            errorInputs,
          })}
        </>
      )}
      {createdAt && showDate && (
        <p className="ccf-form__meta">
          Creado: {moment.tz(createdAt, 'America/Bogota').format('DD-MM-YYYY, h:mm:ss a')}
        </p>
      )}
      {moreInfo && <div className="ccf-form__extra">{moreInfo()}</div>}
      {sendInForm && (
        <div className="ccf-form__actions">
          <Button disabled={loadedData} loading={loadedData} onClick={(e) => submit(e)} primary>
            {props.saveTag}
          </Button>
        </div>
      )}
    </CcfFormLayout>
  );
};

Form.defaultProps = {
  showGender: false,
  showCivil: false,
  showBirthdate: false,
  showIdentification: true,
  showPhone: true,
  showEmail: true,
};

export default Form;
